import { ref, computed, watch } from '@vue/composition-api'
// import { title } from '@core/utils/filter'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment-timezone'
import store from '@/store'
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import useFilterCounter from '@/components/Filters/useFiltersCount'
import { debounce } from 'lodash'
import router from '@/router'

export default function useList() {
  const { t } = useI18nUtils();
  const apiUrl = router.currentRoute.query.api_url;

  const trans = {
    'messages.error.server_error': t('messages.error.server_error')
  };
  const refListTable = ref(null)

  const toast = useToast()

  const tableColumns = [
    { label: 'pbx_call.uuid', key: 'id_session', sortable: true },
    { label: 'pbx_call.status', key: 'status', sortable: true },
    { label: 'pbx_call.caller', key: 'caller', sortable: true },
    { label: 'pbx_call.receiver', key: 'receiver', sortable: true },
    { label: 'pbx_call.recording', key: 'recording_url', sortable: true },
    {
      label: 'pbx_call.started_at', key: 'started_at', sortable: true, formatter: 'formatDateAssigned',
    },
    {
      label: 'pbx_call.ended_at', key: 'ended_at', sortable: true, formatter: 'formatDateAssigned',
    },
    {
      label: 'date.created_at', key: 'created_at', sortable: true, formatter: 'formatDateAssigned',
    },
    {
      label: 'date.updated_at', key: 'updated_at', sortable: true, formatter: 'formatDateAssigned',
    },
  ]

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const statusOptions = ref(['CREATED', 'RINGING', 'ANSWERED', 'HANGUP'])
  const statusFilter = ref(null)

  const selectedObject = ref(null);
  const loadingSelected = ref(false);

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const fetchList = (ctx, callback) => {
    if (!apiUrl) {
      callback([]);
      return;
    }
    store.dispatch('pbx_calls/getAll', {
      q: searchQuery.value,
      pageSize: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      status: statusFilter.value,
      api_url: apiUrl,
    })
    .then(response => {
      callback(response.data)
      totalList.value = response.meta.totalItems
    })
    .catch(() => {
      toast({
        component: ToastificationContent,
        props: {
          title: trans['messages.error.server_error'],
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    })
  }

  const formatDateAssigned = value => {
    const formattedDate = moment(value).format('DD/MM/YYYY HH:mm:ss')
    return formattedDate
  }

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([
    currentPage,
    perPage,
  ], () => { refetchData() })

  watch([
    searchQuery
  ], debounce(() => {
    refetchData()
    }, 500))

  // filters counter ============================
  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    filters.value = {
      status: statusFilter.value,
    };
    refetchData();
  }
  const clearSearchFilters = () => {
    statusFilter.value = null;
    buildFilters();
    filters.value = ({});
  }
  // ============================================

  return {
    currentPage,
    dataMeta,
    isSortDirDesc,
    perPage,
    perPageOptions,
    searchQuery,
    sortBy,
    tableColumns,
    totalList,

    fetchList,
    refListTable,
    formatDateAssigned,

    refetchData,

    statusOptions,
    statusFilter,

    selectedObject,
    loadingSelected,

    filtersCount,
    buildFilters,
    clearSearchFilters,
  }
}
